"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WidgetType;
(function (WidgetType) {
    WidgetType["SingleValue"] = "single-value";
    WidgetType["LineChart"] = "line-chart";
    WidgetType["Divider"] = "divider";
    WidgetType["Image"] = "image";
})(WidgetType = exports.WidgetType || (exports.WidgetType = {}));
exports.MAX_DASHBOARDS_PER_USER = 100;
exports.MAX_WIDGETS_PER_DASHBOARD = {
    metricWidgets: {
        limit: 100,
        types: [WidgetType.SingleValue, WidgetType.LineChart],
    },
    nonMetricWidgets: {
        limit: 50,
        types: [WidgetType.Divider, WidgetType.Image],
    },
};
var DashboardExportType;
(function (DashboardExportType) {
    DashboardExportType["Pdf"] = "pdf";
    DashboardExportType["Xlsx"] = "xlsx";
})(DashboardExportType = exports.DashboardExportType || (exports.DashboardExportType = {}));
var DashboardTemplateType;
(function (DashboardTemplateType) {
    DashboardTemplateType["PagePerformance"] = "PAGE_PERFORMANCE";
    DashboardTemplateType["SegmentPerformance"] = "SEGMENT_PERFORMANCE";
})(DashboardTemplateType = exports.DashboardTemplateType || (exports.DashboardTemplateType = {}));
//# sourceMappingURL=dashboard.model.js.map